export default __webpack_public_path__ + "static/media/img1.8099e2e9.png";